export default __webpack_public_path__ + "4d6cca10cb3799d3806e05567e509d0c.png";